<app-print-layout (cancelar)="cancelar()">
	<div class="p-4 content">
		<div class="card card-outline">
			<div class="card-header d-flex pb-0 no-print">
				<h3>Solicitação Técnica</h3>
			</div>
			<div class="card-body p-2">
				<div>
					<div class="row border border-dark">
						<div class="col-3">
							<strong>Associado a:</strong>
							<p>{{ model?.documentoAssociado }}</p>
						</div>
						<div class="
								col-3
								border border-top-0 border-bottom-0 border-dark
							">
							<strong>Nº Solicitação Técnica:</strong>
							<p *ngIf="model?.numero">{{ model?.numero }}</p>
							<p *ngIf="!model?.numero">-</p>
						</div>
						<div class="
								col-3
								border
								border-top-0
								border-left-0
								border-bottom-0
								border-dark
							">
							<strong>Prazo para Resposta:</strong>
							<p>{{ model?.prazo | date: "shortDate" }}</p>
						</div>

						<div class="col-3">
							<strong>Status:</strong>
							<p>{{ model?.status?.descricao }}</p>
						</div>
					</div>
					<div class="row border border-dark">
						<div class="col-2">
							<strong>Tipo:</strong>
							<p>{{ model?.tipo === 1? 'Interna': 'Externa' }}</p>
						</div>
						<div class="
								col-5
								border border-top-0 border-bottom-0 border-dark
							">
							<strong>{{model?.tipo === 1? 'Unidade Gestora': 'Nome'}}:</strong>
							<p>{{ model?.tipo === 1? model?.internaUnidadeGestora.nome : model?.externaDestinatarioNome
								}}</p>
						</div>
						<div class="
								col-5
								border border-top-0 border-bottom-0 border-dark
							">
							<strong>Responsável:</strong>
							<p>{{ model?.tipo === 1? model?.internaResponsavel.nome :
								model?.externaDestinatarioResponsavel }}</p>
						</div>
					</div>
					<div *ngIf="model?.tipo===2" class="row border border-dark">
						<div class="col-3">
							<strong>CPF/CNPJ:</strong>
							<p>{{ formatarCpfCnpj(model?.externaDestinatarioCPFCNPJ) }}</p>
						</div>
						<div class="
								col-3
								border border-top-0 border-bottom-0 border-dark
							">
							<strong>Telefone:</strong>
							<p>{{ formatarTelefone(model?.externaDestinatarioFone) }}</p>
						</div>
						<div class="
								col-6
								border border-top-0 border-bottom-0 border-dark
							">
							<strong>E-mail:</strong>
							<p>{{ model?.externaDestinatarioEmail }}</p>
						</div>
					</div>
					<div class="row p-2 border border-top-0 border-dark d-block">
						<strong>Assunto:</strong>
						<p>{{ model?.assunto }}</p>
					</div>
					<div class="row p-2 border border-top-0 border-dark d-block">
						<strong>Descrição:</strong>
						<div [innerHTML]="model?.descricao"></div>
					</div>
					<div *ngFor="let item of model?.item" class="row p-2 border border-top-0 border-dark d-block">
						<strong>Item Nº: </strong>
						<p>{{ item?.numero }}</p>
						<div class="row p-2 d-block">
							<strong>Titulo:</strong>
							<p>{{ item?.titulo }}</p>
						</div>
						<div class="row p-2 d-block">
							<strong>Descrição:</strong>
							<div [innerHTML]="item?.descricao"></div>
						</div>
						<div class="row p-2 d-block">
							<strong>Arquivos do Item:</strong>
							<div *ngFor="let anexo of item?.anexo">
								<p>{{ anexo?.nomeArquivo }}</p>
							</div>
						</div>
						<div class="row p-2 d-block">
							<strong>Status:</strong>
							<p>{{ item?.statusCalculado.descricao }}</p>
						</div>
						<div class="row p-2 d-block">
							<strong>Descrição da Resposta:</strong>
							<p *ngIf="item?.statusCalculado.codigo != 2 && item?.respostaItemSolicitacaoTecnica">
								{{ item?.respostaItemSolicitacaoTecnica?.descricao }}
							</p>
							<p *ngIf="!item?.respostaItemSolicitacaoTecnica">NÃO RESPONDIDO</p>
						</div>
						<div class="row p-2 d-block">
							<strong>Arquivos da Resposta:</strong>
							<div *ngIf="item?.statusCalculado.codigo != 2 && item?.respostaItemSolicitacaoTecnica?.anexos">
								<div *ngFor="let anexo of item?.respostaItemSolicitacaoTecnica?.anexos">
									<p>{{ anexo?.nomeArquivo }}</p>
								</div>
							</div>
						</div>
						<div class="row p-2 d-block">
							<strong>Avaliação:</strong>
							<p>{{ item?.statusAvaliacao.descricao }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</app-print-layout>